let slickDefaults = require('../slick-default/slick-default');
require('./fullwidth-slider.less');

jQuery(function($) {
    function fwClearAnimationClasses(e) {
        $(e.target).removeClass(
            'fullwidth-slider__item--animated ' +
                'fullwidth-slider__item--animated-out ' +
                'fullwidth-slider__item--animated-in ' +
                'fullwidth-slider__item--fadeOutRight ' +
                'fullwidth-slider__item--fadeInLeft'
        );
    }

    $('.js-slick-fullwidth-slider').each(function() {
        var $fwSlider = $(this);

        $fwSlider.slick(
            $.extend({}, slickDefaults.params, {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: 0,
                dots: true,
                fade: true,
                speed: 300,
                zIndex: 300,
                autoplay: true
            })
        );

        $fwSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            var $current = slick.$slides.eq(currentSlide);
            var $next = slick.$slides.eq(nextSlide);

            $current
                .addClass('fullwidth-slider__item--animated fws--animated-out')
                .addClass('fullwidth-slider__item--fadeOutRight')
                .one(
                    'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
                    fwClearAnimationClasses
                );

            $next
                .addClass('fullwidth-slider__item--animated fullwidth-slider__item--animated-in')
                .addClass('fullwidth-slider__item--fadeInLeft')
                .one(
                    'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
                    fwClearAnimationClasses
                );
        });
    });
});



// WEBPACK FOOTER //
// ./blocks/fullwidth-slider/fullwidth-slider.js